import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getTwilioPhoneNumbers = async (domain: string, locale: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `communication-provider/phone-numbers`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        params: { locale },
        domain,
    });
}